import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name components.component:al-wiesn-exports
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="components">
 <file name="index.html">
    <al-wiesn-exports guestlist-id=""></al-wiesn-exports>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.components')
    .component('alWiesnExports', {
        bindings: {
            guestlistId: '<'
        },
        controller: 'ComponentsWiesnExportsController',
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/al-wiesn-exports/component.js